'use client';

import React from 'react';
import type { LearnModuleCard } from '@benzinga/content-manager';
import { CompactArticleView } from '../CompactArticleView';
import styles from './Learn.module.css';

export interface LearnModuleCardsProps {
  modules?: LearnModuleCard[];
}

export const LearnModuleCards: React.FC<LearnModuleCardsProps> = ({ modules }) => {
  const cards = Array.isArray(modules) ? modules.filter(module => module?.title && module?.link) : [];

  if (cards.length === 0) {
    return null;
  }

  return (
    <div className={styles.moduleGrid}>
      {cards.map((module, index) => (
        <CompactArticleView
          badge={String(index + 1).padStart(2, '0')}
          key={`${module.id ?? module.link}-${index}`}
          subtitle={module.intro ?? ''}
          title={module.title}
          url={module.link}
        />
      ))}
    </div>
  );
};

export default LearnModuleCards;
